// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__9IbLd","notFixed":"styles_notFixed__WjRnm","clickable":"styles_clickable__N1_46"};